import { c as _c } from "react/compiler-runtime";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";
const Sort = dynamic(() => import("@/components/filter-panel/sort"), {
  ssr: false,
  loading: () => <div className="w-32 h-10 bg-gray-100 animate-pulse rounded-lg" />
});
interface ShowingResultsTitleProps {
  productscount: number;
  selectedCount?: number;
  showSort?: boolean;
  isProductLoading?: boolean;
  searchParams?: {
    [key: string]: string | string[] | undefined;
  };
}
const ShowingResultsTitle: React.FC<ShowingResultsTitleProps> = t0 => {
  const $ = _c(16);
  const {
    productscount,
    selectedCount,
    showSort: t1,
    isProductLoading,
    searchParams
  } = t0;
  const showSort = t1 === undefined ? true : t1;
  const [, setMounted] = React.useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  React.useEffect(t2, t3);
  const t4 = `of ${selectedCount || productscount} results`;
  let t5;
  if ($[2] !== t4) {
    t5 = <span className="font-light">{t4}</span>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== productscount || $[5] !== t5) {
    t6 = <div className="flex flex-col"><h2 className="lg:text-lg text-base font-outfit  font-semibold tracking-wider text-v2-outline uppercase text-left">Showing {productscount}{" "}{t5}</h2></div>;
    $[4] = productscount;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isProductLoading || $[8] !== searchParams || $[9] !== showSort) {
    t7 = !isProductLoading && <>{showSort && <Sort searchParams={searchParams} />}</>;
    $[7] = isProductLoading;
    $[8] = searchParams;
    $[9] = showSort;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <div className="flex flex-row space-x-4 items-center">{t7}</div>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <div className="flex flex-row justify-between items-center w-full lg:pt-6">{t6}{t8}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default ShowingResultsTitle;